import styled, { css } from 'styled-components';
import switchBg from '../../assets/images/switch_bg.svg';
import switchBgVertical from '../../assets/images/switch_bg_vertical.svg';

const StyledSwitch = styled.div<{ $isVertical: boolean }>`
	position: absolute;
	width: ${({ $isVertical }) => ($isVertical ? '12px' : '22px')};
	height: ${({ $isVertical }) => ($isVertical ? '22px' : '12px')};
	${({ $isVertical }) => css`
		background-image: url(${$isVertical ? switchBgVertical : switchBg});
	`}
	background-size: cover;
	background-position: center;
	background-repeat: no-repeat;
	cursor: pointer;
`;

const StyledDot = styled.div<{ $isActive: boolean; $isVertical: boolean }>`
	position: absolute;
	${({ $isVertical, $isActive }) =>
		$isVertical
			? `
        top: ${$isActive ? '12px' : '2px'};
        left: 2px;
    `
			: `
        top: 2px;
        left: ${$isActive ? '12px' : '2px'};
    `}
	width: 8px;
	height: 8px;
	background-color: white;
	border-radius: 50%;
	transition:
		background-color 0.3s ease,
		box-shadow 0.3s ease,
		left 0.3s ease,
		top 0.3s ease;
`;

export { StyledDot, StyledSwitch };
